export const PRODUCT_TITLE = 'Vocab'

export function formatDocumentTitle (pageTitle) {
  const title = typeof pageTitle === 'string' ? pageTitle.trim() : ''
  return title ? `${title} | ${PRODUCT_TITLE}` : PRODUCT_TITLE
}
